import styled from 'styled-components';
import { Body2Styles } from '../typography';
import { getSizeBy, getColor } from '../../../src/styled/utils';
export const StyledListItemContent = styled.div `
  ${Body2Styles};
  display: flex;
  flex: 1 1 auto;
  align-items: center;
  padding-left: ${({ $inset }) => $inset && getSizeBy(7.5)};
  color: ${getColor('onSurface')};
`;
